import type { TokenResponse } from '@/types/';

export default defineNuxtRouteMiddleware(async (to) => {
  function showError(error?: unknown) {
    // console.error('auth check error', error);
    throw createError({
      //statusCode: 500,
      statusMessage: 'There was a problem signing you in. Please try again.',
      data: error || 'unknown',
    });
  }

  if (import.meta.server) {
    if (to.path === '/auth-response') {
      if (to.query.error) {
        showError({
          error: to.query.error,
          error_description: to.query.error_description,
        });
      }

      if (to.query.code) {
        try {
          const { exchangeUserCodeForToken } = useAuthStore();
          const code = to.query.code;
          const resp = await exchangeUserCodeForToken(code as string);

          const userRefreshToken = useCookie('user_refresh_token', {
            maxAge: (resp as TokenResponse).expires_in,
            secure: true,
          });
          userRefreshToken.value = (resp as TokenResponse).refresh_token;

          return navigateTo('/profile');
        } catch (error) {
          showError(error);
        }

        return navigateTo('/');
      }
    } else if (to.path === '/logout-response') {
      return navigateTo('/');
    }
  }
});
